import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './ContinueCancellation.scss'


const ContinueCancellation = ({ onClick }) => (
  <div className={s.container}>
    <FormattedMessage
      className={s.text}
      {...messages.text}
      onClick={onClick}
      data-testid={constants.testIds.resubscribe.continueCancellation}
    />
  </div>
)

ContinueCancellation.propTypes = {
  onClick: PropTypes.func,
}


export default ContinueCancellation
